export default "__VITE_PUBLIC_ASSET__e61a12dd__"